import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for missing marker icons
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Setup the default marker icon
const defaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const { BaseLayer } = LayersControl;

const MapView = ({ lat, lng, address }) => {
  return (
    <MapContainer center={[lat, lng]} zoom={18} style={{ height: '100%', width: '100%' }}>
      <LayersControl position="topright">
        {/* French OpenStreetMap tiles */}
        <BaseLayer checked name="OpenStreetMap France">
          <TileLayer
            url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
            maxZoom={19}
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        </BaseLayer>

        {/* Esri Satellite tiles */}
        <BaseLayer name="Satellite">
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            maxZoom={19}
            attribution='&copy; <a href="https://www.esri.com/en-us/home" target="_blank">Esri</a>, USGS, NOAA'
          />
        </BaseLayer>
      </LayersControl>

      {/* Marker for the location */}
      <Marker position={[lat, lng]} icon={defaultIcon}>
        <Popup>{address}</Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapView;
